// src/components/Header.js
import React, { useState, useContext } from "react";
import { useNavigate, NavLink } from 'react-router-dom';
import { Avatar, Menu, MenuItem, Button, IconButton } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { AuthContext } from '../context/AuthContext';
import { AdminContext } from '../context/AdminContext';
import MobileMenuDrawer from './MobileMenuDrawer';

import logo from "../assets/images/logowhite.png";
import pfp from "../assets/images/user.png";

function Header() {
  const { user, logout } = useContext(AuthContext);
  const { isAdmin } = useContext(AdminContext);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    if (!user) {
      navigate('/login');
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleMenuClick = (path) => {
    setAnchorEl(null);
    if (path === '/logout') {
      handleLogout();
    } else {
      navigate(path);
    }
  };

  const handleLogout = () => {
    logout();
    setAnchorEl(null);
    navigate('/login');
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const navLinkClasses = ({ isActive }) => `
    relative font-serif text-lg tracking-wide transition-colors duration-300
    ${isActive ? 'text-[#dbcdac] font-bold' : 'text-[#FFF5EE] hover:text-[#dbcdac]'}
    after:content-[''] after:absolute after:-bottom-1 after:left-0 after:h-[1px] 
    after:bg-[#dbcdac] after:transition-all after:duration-300
    ${isActive ? 'after:w-full' : 'after:w-0 hover:after:w-full'}
  `;

  return (
    <>
      <header className="sticky top-0 z-50 w-full bg-[#528a89]/90 backdrop-blur-md border-b border-[#dbcdac]/20 shadow-sm transition-all duration-300">
        
        <div className="max-w-7xl mx-auto px-4 md:px-12 py-3 md:py-5 flex items-center justify-between relative">
          
          <div className="md:hidden flex-shrink-0">
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ color: '#FFF5EE' }}
            >
              <MenuIcon />
            </IconButton>
          </div>

          <div className="flex-1 md:flex-none flex justify-center md:justify-start items-center">
            <NavLink to="/" end className="block hover:scale-105 transition-transform duration-500">
                <img 
                  className="h-16 md:h-24 w-auto object-contain drop-shadow-md origin-left" 
                  src={logo} 
                  alt="Deli da Persy" 
                />
            </NavLink>
          </div>

          <nav className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 items-center gap-10">
            <NavLink className={navLinkClasses} to="/cardapio">
              Cardápio
            </NavLink>
            <NavLink className={navLinkClasses} to="/biblioteca">
              Biblioteca de Jogos
            </NavLink>
            <NavLink className={navLinkClasses} to="/sobre">
              Sobre Nós
            </NavLink>
          </nav>

          <div className="flex items-center gap-5 flex-shrink-0">
            
            {isAdmin && (
                <button 
                  onClick={() => navigate('/reserva')}
                  className="hidden lg:inline-flex px-6 py-2.5 bg-[#971253] text-[#FFF5EE] rounded-full font-medium tracking-wide text-sm hover:bg-[#7a0e42] hover:-translate-y-0.5 hover:shadow-[0_4px_15px_-3px_rgba(151,18,83,0.4)] transition-all duration-300 border border-[#FFF5EE]/20"
                >
                  Reservar Mesa
                </button>
            )}

            {/* AVATAR ESCONDIDO SE NÃO FOR ADMIN */}
            {isAdmin && (
              <div className="relative group">
                <Button
                  id="basic-button"
                  aria-controls={open ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                  sx={{ minWidth: 'auto', padding: 0, borderRadius: '50%' }}
                  className="hover:scale-105 transition-transform duration-300"
                >
                  <div className="p-0.5 rounded-full bg-transparent group-hover:bg-gradient-to-tr from-[#dbcdac] to-[#971253] transition-colors duration-500">
                    <Avatar 
                          src={user?.picture || pfp} 
                          alt={user?.name || "Login"} 
                          slotProps={{ onError: (e) => { e.target.src = pfp; } }}
                          sx={{ width: 40, height: 40, border: '2px solid #FFF5EE' }}
                      />
                  </div>
                </Button>

                {user && (
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    slotProps={{
                      list: {
                        'aria-labelledby': 'basic-button',
                      },
                      paper: {
                        sx: {
                          mt: 1.5,
                          backgroundColor: '#FFF5EE',
                          color: '#971253',
                          borderRadius: '16px',
                          boxShadow: '0 10px 40px -10px rgba(0,0,0,0.2)',
                          border: '1px solid rgba(151,18,83,0.1)',
                          minWidth: '200px',
                          '& .MuiMenuItem-root': {
                            fontFamily: 'inherit',
                            fontSize: '0.95rem',
                            padding: '12px 20px',
                            transition: 'all 0.2s',
                            '&:hover': {
                              backgroundColor: 'rgba(151,18,83,0.05)',
                              color: '#528a89'
                            }
                          }
                        }
                      }
                    }}
                  >
                    <MenuItem onClick={() => handleMenuClick('/usuario')}>Meu Perfil</MenuItem>
                    
                    
                    <MenuItem onClick={() => handleMenuClick('/logout')}>Sair</MenuItem>
                  </Menu>
                )}
              </div>
            )}

          </div>

        </div>
      </header>

      <MobileMenuDrawer open={drawerOpen} onClose={handleDrawerToggle} />
    </>
  );
}

export default Header;